import { z } from "zod";

export const CompassEvent = z.object({
    id: z.number(),
    userId: z.number(),
    title: z.string(),
    description: z.string().nullable(),
    createdAt: z.date(),
    updatedAt: z.date(),
    start: z.date(),
    end: z.date().nullable(),
});
